import styled from "styled-components";
import { TabsContainer } from "../Avax/Farm/TabsSelector";

export const ProfileContainer = styled.section`
  padding-bottom: 80px;
`;
export const ProfileWrapper = styled.div`
  max-width: 1114px;
  width: 100%;
  margin: 0 auto;
  padding: 0 20px;
  .title-profile {
    color: #fff;
    font-family: Dirtyline;
    font-size: 32px;
    font-style: normal;
    font-weight: 400;
    line-height: 96%; /* 30.72px */
    text-transform: lowercase;
    margin-bottom: 16px;
    &.light {
      color: var(--Red-950, #430c0c);
    }
  }
  @media screen and (max-width: 768px) {
    width: unset;
  }
`;
export const ProfileBanner = styled.div`
  display: flex;
  justify-content: space-between;
  gap: 12px;
  border-radius: 12px;
  border: 1px solid var(--Neutral-400, #92929e);
  background: #0d0d0d;
  box-shadow: 0px 0px 85.4px 0px rgba(106, 126, 228, 0.15);
  padding: 16px;
  margin-bottom: 80px;
  &.light {
    background-color: #fff;
    color: #000;
  }
  @media screen and (max-width: 768px) {
    display: block;
  }
`;
export const ProfileBannerLeft = styled.div`
  max-width: 49%;
  width: 100%;
  .banner-info {
    display: flex;
    align-items: center;
    gap: 12px;
    margin-bottom: 24px;
  }
  .banner-image {
    position: relative;
    width: 100px;
    height: 100px;
    img {
      border-radius: 50%;
    }
    &:hover {
      .button-edit {
        opacity: 1;
        pointer-events: auto;
      }
    }
    .image-user {
      border-radius: 50%;
      overflow: hidden;
    }
    .rank {
      position: absolute;
      right: 0;
      bottom: 0;
      z-index: 1;
    }
  }
  .banner-detail {
    .name {
      color: var(--Neutral-50, #f7f7f8);
      font-family: Syne;
      font-size: 24px;
      font-style: normal;
      font-weight: 500;
      line-height: 125%; /* 30px */
      margin-bottom: 9px;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      max-width: 200px;
    }
    .address {
      color: var(--Neutral-400, #92929e);
      font-family: Syne;
      font-size: 14px;
      font-style: normal;
      font-weight: 500;
      line-height: 125%; /* 17.5px */
      margin-bottom: 9px;
      display: flex;
      align-items: center;
      gap: 8px;
    }
    .copy {
      cursor: pointer;
      border-radius: 4px;
      background: rgba(40, 39, 44, 0.6);
      width: 16px;
      height: 16px;
      display: flex;
      align-items: center;
      justify-content: center;
      padding: 4px 4px;
    }
    .bio {
      color: var(--Neutral-400, #92929e);
      font-family: Syne;
      font-size: 14px;
      font-style: normal;
      font-weight: 500;
      line-height: 125%; /* 17.5px */
      display: flex;
      align-items: center;
      gap: 8px;
      span {
        overflow: hidden;
        display: -webkit-box;
        -webkit-line-clamp: 3;
        -webkit-box-orient: vertical;
      }
      img {
        padding: 4px;
        width: 16px;
        height: 16px;
        display: flex;
        align-items: center;
        justify-content: center;
        border-radius: 4px;
        background: rgba(40, 39, 44, 0.6);
        cursor: pointer;
      }
    }
  }
  .banner-stats {
    margin-bottom: 24px;
    .list-stats {
      display: flex;
      align-items: flex-start;
      gap: 24px;
    }
    .name-stats {
      display: flex;
      align-items: center;
      gap: 6px;
      color: var(--Neutral-400, #92929e);
      font-family: DMMono-500;
      font-size: 12px;
      font-style: normal;
      font-weight: 400;
      line-height: 125%; /* 15px */
      margin-bottom: 4px;
    }
    .number-stats {
      color: var(--Neutral-50, #f7f7f8);
      font-family: DMMono-500;
      font-size: 14px;
      font-style: normal;
      font-weight: 500;
      line-height: 16px; /* 114.286% */
      letter-spacing: -0.98px;
    }
  }
  .banner-referral {
    display: flex;
    align-items: center;
    justify-content: space-between;
    .referral-wrapper {
      border-radius: 7.006px;
      border: 1px solid var(--Neutral-700, #4d4d57);
      padding: 11px 12px;
      position: relative;
      display: flex;
      align-items: center;
      justify-content: space-between;
      max-width: 268px;
      width: 100%;
    }
    .label {
      position: absolute;
      top: -10px;
      left: 10px;
      color: var(--Neutral-400, #92929e);
      font-family: Syne;
      font-size: 12px;
      font-style: normal;
      font-weight: 500;
      line-height: 125%; /* 15px */
      border-radius: 2px;
      background: #131313;
      padding: 4px;
    }
    .ref-code {
      color: var(--Neutral-50, #f7f7f8);
      font-family: Syne;
      font-size: 14px;
      font-style: normal;
      font-weight: 400;
      line-height: 125%; /* 17.5px */
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
      max-width: 80%;
    }
    .copy-button {
      outline: none;
      background-color: unset;
      cursor: pointer;
      border: 0;
    }
    .button-group {
      display: flex;
      align-items: center;
      gap: 12px;
      .icon-button {
        opacity: 0.3;
        &.active {
          opacity: 1;
          pointer-events: none;
        }
      }
    }
    .icon-button {
      .item-button {
        border-radius: 7.01px;
        border: 1px solid var(--Neutral-700, #4d4d57);
        background: rgba(40, 39, 44, 0.6);
        padding: 11px 11px 7px;
        display: block;
        cursor: pointer;
      }
    }
  }
  .button-edit {
    cursor: pointer;
    position: absolute;
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    color: var(--Neutral-50, #f7f7f8);
    font-family: Syne;
    font-size: 14px;
    font-style: normal;
    font-weight: 500;
    line-height: 125%; /* 17.5px */
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    border-radius: 100px;
    background: linear-gradient(
      0deg,
      rgba(0, 0, 0, 0.7) 0%,
      rgba(0, 0, 0, 0.7) 100%
    );
    outline: none;
    opacity: 0;
    pointer-events: none;
    transition: all 0.26s ease;
  }
  &.light {
    .name {
      color: var(--Neutral-900, #3a3a40);
    }
    .address {
      color: var(--Neutral-400, #92929e);
    }
    .copy {
      background: #eeeef0;
    }
    .bio {
      color: var(--Neutral-400, #92929e);
      img {
        background: rgba(238, 238, 240, 0.6);
      }
    }
    .banner-stats {
      .name-stats {
        color: var(--Neutral-500, #6e6e7c);
      }
      .number-stats {
        color: var(--Neutral-700, #4d4d57);
      }
    }
    .banner-referral {
      .label {
        background-color: #fff;
        color: var(--Neutral-400, #92929e);
      }
      .ref-code {
        color: var(--Neutral-600, #5e5e6b);
      }
    }
  }
  @media screen and (max-width: 768px) {
    max-width: unset;
    width: unset;
    .banner-image {
      width: 80px;
      height: 80px;
      img {
        width: 100%;
        height: 100%;
        object-fit: cover;
      }
    }
    .banner-detail {
      .name {
        font-size: 22px;
        margin-bottom: 0;
      }
      .address {
        margin-bottom: 0;
      }
    }
    .banner-stats {
      .list-stats {
        flex-wrap: wrap;
        justify-content: space-between;
        gap: 10px;
        li {
          width: calc(100% / 2 - 20px);
        }
      }
    }
    .banner-referral {
      display: block;
      margin-bottom: 24px;
      .referral-wrapper {
        max-width: unset;
        width: unset;
        margin-bottom: 12px;
      }
      .button-group {
        justify-content: center;
      }
    }
  }
`;
export const ProfileBannerRight = styled.div`
  max-width: 38%;
  width: 100%;
  border-radius: 12px;
  padding: 12px 28px;
  display: flex;
  flex-direction: column;
  position: relative;
  overflow: hidden;
  background: url("/assets/images/profile/banner_bg.png") center / cover
    no-repeat;
  .total-point {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    gap: 12px;
    margin-bottom: 6px;
  }
  .price {
    color: var(--Neutral-50, #f7f7f8);
    text-align: right;
    font-family: DMMono-500;
    font-size: 32px;
    line-height: 125%; /* 40px */
    letter-spacing: -2.24px;
  }
  .point {
    color: var(--Neutral-400, #92929e);
    font-family: DMMono-500;
    font-size: 14px;
    line-height: 125%; /* 17.5px */
    text-align: right;
  }
  &.light {
    background-image: url("/assets/images/profile/banner_bg_light.png");
    border: solid 1px rgb(184, 184, 193);
    .price {
      color: var(--Neutral-900, #3a3a40);
    }
    .point {
      color: var(--Neutral-600, #5e5e6b);
    }
  }
  @media screen and (max-width: 768px) {
    width: unset;
    max-width: unset;
    min-height: 200px;
  }
`;
export const RankContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: auto;
  position: relative;
  .left,
  .right {
    text-align: center;
  }
`;

export const IconLabel = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;

  img {
    width: 27px;
    height: 27px;
    object-fit: cover;
  }
`;

export const RankValue = styled.div`
  font-size: 14px;
  color: #fff;
  margin-top: 27px;
  &.light {
    color: #000;
  }
`;

export const ProgressTrack = styled.div`
  position: absolute;
  flex: 1;
  height: 8px;
  background: #333;
  border-radius: 52px;
  border: 1px solid var(--Neutral-700, #4d4d57);
  width: 100%;
  bottom: 27px;
  left: 12px;
  .ant-tooltip-inner {
    border-radius: 2px;
    background: var(--Neutral-600, #5e5e6b);
    padding: 4px;
    color: var(--Neutral-50, #f7f7f8);
    font-family: DMMono-500;
    font-size: 12px;
    font-style: normal;
    font-weight: 500;
    line-height: 16px; /* 133.333% */
    letter-spacing: -0.84px;
    min-width: 34px;
    min-height: 24px;
    text-align: center;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .ant-tooltip .ant-tooltip-arrow:before {
    background: var(--Neutral-600, #5e5e6b);
  }
  &.light {
    border: 1px solid var(--Red-400, #f37676);
    background: linear-gradient(
      90deg,
      var(--Neutral-100, #eeeef0) 0%,
      var(--Neutral-50, #f7f7f8) 80.5%
    );
    .ant-tooltip-inner {
      background: var(--Neutral-100, #eeeef0);
      color: var(--Neutral-700, #4d4d57);
    }
  }
`;

export const ProgressBar = styled.div`
  height: 100%;
  border-radius: 52px;
  background: linear-gradient(90deg, #a1242f 1.66%, #000 101.07%);
  &.light {
    background: linear-gradient(
      90deg,
      var(--Red-700, #b32222) 1.66%,
      #fff 101.07%
    );
  }
`;

export const CurrentValue = styled.div`
  position: absolute;
  top: -10px;
  transform: translateX(-50%);
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const Tooltip = styled.div`
  padding: 4px 8px;
  font-size: 12px;
  background: #444;
  color: #fff;
  border-radius: 6px;
  white-space: nowrap;
`;

export const ProfileContent = styled.div`
  @media screen and (max-width: 768px) {
    ${TabsContainer} {
      flex-wrap: wrap;
      button {
        width: calc(100% / 2 - 6px);
      }
    }
  }
`;
